import Radium, { Style } from "radium"
import vhpxPlugin from "./vh-px-plugin.js"
import keyframes from "./keyframes"

export default function (component) {
  return Radium({
    plugins: [
      Radium.Plugins.mergeStyleArray,
      Radium.Plugins.checkProps,
      vhpxPlugin,
      Radium.Plugins.resolveMediaQueries,
      Radium.Plugins.resolveInteractionStyles,
      Radium.Plugins.keyframes,
      Radium.Plugins.visited,
      Radium.Plugins.removeNestedStyles,
      Radium.Plugins.checkProps
    ]
  })(component)
}

export { keyframes, Style }



// WEBPACK FOOTER //
// ./src/higher-order-components/configured-radium/index.js